import { Controller } from '@hotwired/stimulus';
import { loadStripe } from '../../helpers/stripe_helper';

const elementsAppearance = {
  theme: 'flat',
  variables: {
    spacingUnit: '4px',
    gridRowSpacing: '16px'
  }
};

const paymentElementOptions = {
  layout: 'tabs',
  paymentMethodOrder: ['card'],
  fields: {
    billingDetails: {
      address: 'if_required'
    }
  }
};

let stripe = null;
let elements = null;

function initializeElements(clientSecret) {
  elements = stripe.elements({
    appearance: elementsAppearance,
    locale: document.documentElement.lang,
    clientSecret
  });
}

function loadStripeElements(stripeKey, clientSecret, callback) {
  loadStripe(stripeKey, (loadedStripe) => {
    stripe = loadedStripe;
    initializeElements(clientSecret);
    callback();
  });
}

export default class PaymentElementController extends Controller {
  static values = {
    stripeKey: String,
    clientSecret: String,
    returnUrl: String
  };

  initialize() {
    this.paymentElement = null;
    this.complete = false;
  }

  connect() {
    loadStripeElements(this.stripeKeyValue, this.clientSecretValue, () => {
      this.initializeElement();
    });
  }

  disconnect() {
    if (this.paymentElement != null) {
      this.paymentElement.destroy();
      this.paymentElement = null;
    }
  }

  initializeElement() {
    if (this.paymentElement != null) {
      return;
    }

    this.paymentElement = elements.create('payment', paymentElementOptions);
    this.paymentElement.mount(this.element);
    this.paymentElement.on('change', (event) => {
      this.complete = event.complete;
    });
  }

  async confirm() {
    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: this.returnUrlValue
      }
    });

    return error;
  }
}
